import React from 'react'
import { useUnpaidShiftsContextValue } from '../context/UnpaidShiftsProvider'
import { COLUMNS } from './UnpaidShiftsTable/ColumnsFilter/columns'
import { PaginatedTable } from 'components/Table/PaginatedTable'

export const UnpaidShiftsTable = () => {
  const {
    state: { data, pagination, isFetching },
    actions: { setPagination },
  } = useUnpaidShiftsContextValue()

  return (
    <PaginatedTable
      columns={COLUMNS.map((column) => column.columnDef)}
      items={data.items}
      rowCount={data.totalRows}
      pagination={pagination}
      setPagination={setPagination}
      isFetching={isFetching}
      emptyMessage="No unpaid shifts matched your search. Try using different filters."
      emptyStateMaxWidth={['100%', '100%', '50%', '50%']}
    />
  )
}
